import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { EmailUnsubscribeComponent } from './email-unsubscribe.component';
import { EmailUnsubscribeRoutingModule } from './email-unsubscribe-routing.module';
import { CheckboxModule } from 'primeng/checkbox';
import { TagModule } from 'primeng/tag';

@NgModule({
    declarations: [
        EmailUnsubscribeComponent
    ],
    imports: [
        ButtonModule,
        CommonModule,
        CheckboxModule,
        EmailUnsubscribeRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        TagModule,
    ],
    exports: [
        EmailUnsubscribeComponent
    ]
})
export class EmailUnsubscribeModule { }
